<script setup lang="ts">
import LoadingIcon from '@/assets/icons/loading.svg?component'
import { FlexComponent } from '@/ui-library'

withDefaults(defineProps<{ size?: number; isFullSize?: boolean; color?: string }>(), {
  size: 24,
  isFullSize: false,
  color: 'var(--primary)',
})
</script>

<template>
  <FlexComponent :class="['container', { full: isFullSize }]" align="center" justify="space-around">
    <el-icon :size="size" :color="color">
      <LoadingIcon />
    </el-icon>
  </FlexComponent>
</template>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;

  &.full {
    height: calc(100vh - 72px);
  }
}
</style>
